import { createBrowserHistory } from "history";

export default createBrowserHistory({ basename: "/riders-portal/dashboard" });
